import {h} from 'preact'
import { useState } from 'react';
import { Typography, Button, Space, Card, Form } from 'antd';
import {PlusOutlined, ReloadOutlined, KeyOutlined, LeftOutlined, RightOutlined} from '@ant-design/icons';
import { useLicenseKeys } from '../hooks/useLicenseKeys';
import LicenseKeyForm from './LicenseKeyForm';
import LicenseKeyTable from './LicenseKeyTable';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

const LicenseKeysPage = () => {
    const {
        licenseKeys,
        loading,
        pagination,
        createLicenseKey,
        goToNextPage,
        goToPrevPage,
        refreshData,
    } = useLicenseKeys();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingKey, setEditingKey] = useState(null);
    const [form] = Form.useForm();


    const handleCreate = () => {
        setEditingKey(null);
        form.resetFields();
        setIsModalVisible(true);
    };

    const handleEdit = (record) => {
        setEditingKey(record.id);
        form.setFieldsValue({
            ...record,
            expire_at: dayjs(record.expire_at)
        });
        setIsModalVisible(true);
    };

    const handleSubmit = async (values) => {
        const success = await createLicenseKey(values);

        if (success) {
            setIsModalVisible(false);
            form.resetFields();
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    return (
        <div style={{ padding: '24px' }}>
            {/* Header */}
            <div style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                    <div>
                        <Title level={2} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <KeyOutlined style={{ color: '#1890ff' }} />
                            License Keys Management
                        </Title>
                        <Text type="secondary">
                            Manage and issue license keys for on-premise clients
                        </Text>
                    </div>
                    <Space>
                        <Button
                            icon={<ReloadOutlined />}
                            onClick={refreshData}
                            loading={loading}
                        >
                            Refresh
                        </Button>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={handleCreate}
                        >
                            Create License Key
                        </Button>
                    </Space>
                </div>
            </div>

            {/* Table */}
                <LicenseKeyTable
                    licenseKeys={licenseKeys}
                    loading={loading}
                    // pagination={pagination}
                    // onNextPage={goToNextPage}
                    // onPrevPage={goToPrevPage}
                    // onGoToPage={goToPage}
                />
                <div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '10px'}}>
                    <Button icon={<LeftOutlined />} onClick={goToPrevPage} disabled={!pagination.hasPrev}>Previous</Button>
                    <Button icon={<RightOutlined />} onClick={goToNextPage} disabled={!pagination.hasNext}>Next</Button>
                </div>

            {/* Form Modal */}
            <LicenseKeyForm
                visible={isModalVisible}
                onCancel={handleCancel}
                onSubmit={handleSubmit}
                editingKey={editingKey}
                loading={loading}
                form={form}
            />
        </div>
    );
};

export default LicenseKeysPage;